// extracted by mini-css-extract-plugin
export var circle = "_4o-2";
export var icon = "_4o-a";
export var iconHighlight = "_4o-0";
export var lg = "_4o-8";
export var md = "_4o-7";
export var outline = "_4o-4";
export var sm = "_4o-6";
export var square = "_4o-1";
export var xl = "_4o-9";
export var xs = "_4o-5";
export var xxs = "_4o-3";